import React, { Component } from 'react';
import { UIView} from 'ui-router-react'; 
import { CSSTransitionGroup } from 'react-transition-group'; 
import Submenu from '../components/Submenu'; 

class BesuchContainer extends Component {
	render() {		   
		   return (
				<div>
					<Submenu menuName="besuch" menuItems={this.props.resolves.menuItems} />
					<UIView render={(Comp, props) =>
					  <CSSTransitionGroup
						transitionName="example"
						transitionEnterTimeout={250}
						transitionLeaveTimeout={250}>
						<Comp {...props} key={props.transition} />
					  </CSSTransitionGroup>
					}/>
				</div>
			)
	   
	}
}
export default BesuchContainer;


// WEBPACK FOOTER //
// ./src/containers/BesuchContainer.js